import { render, staticRenderFns } from "./NtakDashboardContentComponent.vue?vue&type=template&id=724e965b&scoped=true&"
import script from "./NtakDashboardContentComponent.vue?vue&type=script&lang=js&"
export * from "./NtakDashboardContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./NtakDashboardContentComponent.vue?vue&type=style&index=0&id=724e965b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e965b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724e965b')) {
      api.createRecord('724e965b', component.options)
    } else {
      api.reload('724e965b', component.options)
    }
    module.hot.accept("./NtakDashboardContentComponent.vue?vue&type=template&id=724e965b&scoped=true&", function () {
      api.rerender('724e965b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/ntak-dashboard/NtakDashboardContentComponent.vue"
export default component.exports